<template>
      <SubTitle :title-name="sectionName" />
  <v-card class="mx-auto w-75 mb-10" max-width="1280" variant="Tonal">
    <v-list :items="items" item-props lines="three">
      <template v-slot:subtitle="{ subtitle }">
        <div v-html="subtitle" class="subtitle_text"></div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
  import SubTitle from "./SubTitle.vue";

  export default {
    data: () => ({
      sectionName: "お知らせ",

      items: [
        {
          title: "2026/2/19",
          subtitle: `本日発売です！<br>特典ディスクの収録曲一覧を追加しました。<br>原作者飯島多紀哉先生のサイン会情報を掲載しました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2026/2/12",
          subtitle: `店舗特典を更新しました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        {
          title: "2026/2/4",
          subtitle: `サイト公開しました。`,
        },
        // ↓仕切りボーダー
        {
          type: "divider",
          color: "primary",
          class: "border-opacity-50",
          thickness: "2",
        },
        
      ],
    }),
    components: {
      SubTitle,
    },
  };
</script>

<style scoped>
  .subtitle_text {
    font-size: 1.2em;
    line-height: 2em;
  }
</style>
